import React, { useEffect, useState } from "react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { CustomeStyle } from "../Css/CustomeStyle";
import Footer from "../Fotter";
import Header from "./header";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link, useNavigate } from "react-router-dom";
import { FiShoppingCart } from "react-icons/fi";
import { FaRegHeart, FaHeart } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { AddToCart } from "../redux/slices/AddTocartSlice";
import { toast } from "react-toastify";
import { AddWishlist } from "../redux/slices/AddWishlistSlice";
import axios from "axios";
import endPoint from "../redux/EndPoint/endpoint";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Home = () => {
  const dispatch = useDispatch();
  const [likedProducts, setLikedProducts] = useState(new Set());
  const [isVisible, setIsVisible] = useState(false);
  const [loading, setLoading] = useState(true);
  const [categoryDataMap, setCategoryDataMap] = useState({});
  const [hasFetched, setHasFetched] = useState(false);
  const { AllCategory } = useSelector((state) => state?.category);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // useEffect(() => {
  //   if (GetBanners?.data) {
  //     setImages(GetBanners.data[0]?.images);
  //   }
  // }, [GetBanners]);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     setLoading(true);
  //     try {
  //       dispatch(GetRecentView());
  //       dispatch(GetOfferName());
  //       dispatch(GetBanner());
  //       await dispatch(fetchProducts()).unwrap();
  //     } catch (error) {
  //       console.log("Error", Error)
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchData();
  // }, [dispatch]);

  // useEffect(() => {
  //   dispatch(GetOffer());
  // }, [dispatch]);

  const toggleLike = (productId) => {
    dispatch(AddWishlist(productId));
    setLikedProducts((prevLikedProducts) => {
      const updatedLikes = new Set(prevLikedProducts);
      if (updatedLikes.has(productId)) {
        updatedLikes.delete(productId);
      } else {
        updatedLikes.add(productId);
      }
      return updatedLikes;
    });
  };

  const handleAddToCart = (item) => {
    const cartData = {
      productId: item?._id,
      quantity: 1,
    };
    dispatch(AddToCart(cartData)).then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        toast.success("Product added to cart!", {
          position: "top-right",
          autoClose: 2000,
          style: {
            backgroundColor: "#d0d3d4",
            color: "black",
            fontWeight: "bold",
          },
        });
      } else {
        toast.error("Failed to add product to cart!", {
          position: "top-right",
          autoClose: 2000,
          style: {
            backgroundColor: "#f8d7da",
            color: "#721c24",
            fontWeight: "bold",
          },
        });
        console.error("API Error:", result);
      }
    });
  };

  const generateSlug = (text) => {
    if (!text) return "";

    return text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\- ]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

  function getRandomCategories(allCategories, count = 10) {
    const shuffled = [...allCategories].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, count);
  }

  useEffect(() => {
    const loadInitialData = async () => {
      if (!AllCategory?.length || hasFetched) return;

      try {
        setLoading(true);
        const selected = getRandomCategories(AllCategory);
        const names = selected.map((cat) => cat.name);
        const newCategoryDataMap = {};

        for (const name of names) {
          try {
            const res = await axios.get(`${endPoint.GETCATEGORYDATA}/${encodeURIComponent(name)}`);
            if (res?.data?.products?.length > 0) {
              newCategoryDataMap[name] = res.data;
            }
          } catch (error) {
            console.error(`Category error: ${name}`, error.message);
          }
        }
        setCategoryDataMap(newCategoryDataMap);
        setHasFetched(true);
      } catch (err) {
        console.error("Unexpected error:", err);
      } finally {
        setLoading(false);
      }
    };

    loadInitialData();
  }, [AllCategory, hasFetched]);


  const bannerImages = [
    {
      to: `https://www.gwsshopsy.com/motoPhone/smart-phone-tab/motorola-smartphones/motorola-edge-70-pantone-bronze-green-256-gb-8-gb-ram`,
      src: require("../assets/Banners/TopSaleImage2/MotoPhone1.png"),
      alt: "iPhone Banner",
    },
    {
      to: `https://www.gwsshopsy.com/topSale/home-electronics/air-purifier/xiaomi-4-lite-smart-air-purifier-for-home-aqi-display-hepa-carbon-filter`,
      src: require("../assets/Banners/TopSaleImage/AIRPURIFIER1.png"),
      alt: "iPhone Banner",
    },
    {
      to: `https://www.gwsshopsy.com/grooming/beauty-personal-care/trimmer/philips-indias-no1-mens-trimmer-powerful-motor-no-oil-needed-60-min-runtime-mg371065`,
      src: require("../assets/Banners/TopSaleImage1/grooming.png"),
      alt: "iPhone Banner",
    },

  ];


  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <div className="">
      <Header />
      <div className="flex flex-col min-h-screen">
        <div className="flex-grow">
      
    <div className="w-[90%] mx-auto mb-6 mt-7">
            <Slider {...settings}>
              {bannerImages.map((banner, index) => (
                <a
                  key={index}
                  href={banner?.to}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="overflow-hidden block"
                >
                  <img
                    src={banner.src}
                    alt={banner.alt}
                    className="w-full h-[180px] sm:h-[240px] md:h-[300px] lg:h-[600px] transition-transform duration-300 ease-in-out "
                  />{" "}
                </a>
              ))}
            </Slider>
          </div>

          <div className={"w-[90%] items-center mx-auto bg-white p-1 mb-10"}>
            {loading ? (
              <div className="text-center my-10 text-lg font-medium">
                Loading ...
              </div>
            ) : (
              Object.entries(categoryDataMap).map(([categoryName, categoryData]) => (
                <div key={categoryName} className="my-8">
                  <h2 className="text-xl md:text-2xl font-bold mb-4">{categoryName}</h2>

                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-2 sm:gap-4">
                    {categoryData?.products?.slice(0, 10).map((item) => (
                      <div
                        key={item?._id}
                        className="overflow-hidden relative border border-gray-200 sm:px-5 sm:py-3 px-3 py-2 hover:scale-105 hover:-translate-y-1"
                      >
                        <img
                          src={item?.images?.productimage1}
                          alt={item.name}
                          className="w-full h-20 sm:h-40 object-contain rounded-x"
                        />

                        {/* Like Button */}
                        <button
                          className="like-btn absolute top-2 left-2"
                          onClick={() => toggleLike(item._id)}
                        >
                          {likedProducts.has(item._id) ? (
                            <FaHeart size="24px" className="text-red-500 sm:text-lg text-xs" />
                          ) : (
                            <FaRegHeart size="24px" className="text-gray-400 sm:text-lg md:text-xs" />
                          )}
                        </button>

                        {/* Cart Button */}
                        {item?.outOfStock ? <span className=" absolute bg-gray-200 top-2 right-2  p-1  text-red-500 text-bold text-gray-400 sm:ml-20 ml-0">
                          Out of stock
                        </span> :
                          <button
                            onClick={() => handleAddToCart(item)}
                            className="like-btn absolute top-2 right-2 px-2 py-2 bg-gray-100 text-white rounded-lg hover:bg-green-50"
                          >
                            <FiShoppingCart className="text-black sm:text-base md:text-xl lg:text-2xl" />
                          </button>
                        }
                        {/* Product Link */}
                        <Link
                          to={`/shop/${item?.category ? generateSlug(item?.category) : "-"}/${item?.subcategory ? generateSlug(item?.subcategory) : "-"}/${generateSlug(item?.title)}`}
                          state={{ item }}
                          className="block"
                        >
                          <div className="mb-1 end-2 lg:mt-3">
                            <h2 className="text-black text-sm md:text-base line-clamp-1 font-bold leading-none mb-1">
                              {item.title}
                            </h2>
                            <div className="sm:flex item-center sm:justify-between gap-2 text-sm mt-1">
                              <div className="flex items-center gap-2 text-sm mt-1">
                                <span className="font-bold">
                                  ₹{item.salePrice}
                                </span>
                                <span className="line-through text-gray-400">
                                  ₹{item.regularPrice}
                                </span>
                              </div>
                              {item?.isCodeAvailable &&
                                <span className="text-green-600 text-bold text-gray-400 sm:ml-20 ml-0">
                                  COD Available
                                </span>
                              }
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))}
                  </div>
                </div>
              ))
            )}

          </div>

          <button
            onClick={scrollToTop}
            className={`fixed bottom-5 right-5 border bg-gray-200 text-black font-semibold px-4 py-2 rounded-full shadow-lg transition-all duration-300 ${isVisible ? "opacity-100 scale-100" : "opacity-0 scale-0"
              }`}
          >
            ⬆ Top
          </button>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Home;
